import { LOAD_START, LOAD_STOP } from 'redux/actions/types';
import { ApplicationSpinnerState } from 'ts/types/application-spinner.types';
import { ApplicationSpinnerActionType } from 'redux/actions/applicationSpinnerActions';

const initState: ApplicationSpinnerState = {
  isLoading: false,
};

function applicationSpinnerReducer(
  state = initState,
  action: ApplicationSpinnerActionType,
) {
  switch (action.type) {
    case LOAD_START:
      return { ...action.payload, isLoading: true };
    case LOAD_STOP:
      return { ...action.payload, isLoading: false };
    default:
      return state;
  }
}

export default applicationSpinnerReducer;
